import { render, staticRenderFns } from "./ManualAcademyPdf.vue?vue&type=template&id=665caa7e&lang=pug&"
import script from "./ManualAcademyPdf.vue?vue&type=script&lang=ts&"
export * from "./ManualAcademyPdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports